import React from 'react';
import { withRouter } from 'react-router';
import queryString from 'query-string';
import { Permission } from 'components/page/index';
import PERMISSIONS from 'config/app-permission.config';
import IpLists from '../component/IpLists';
import AddAndEditIpList from '../component/AddAndEditIpList';

const IpWhiteLists = ({
  location,
}) => {
  const pairs = queryString.parse(location.search);
  return (
    <Permission permission={PERMISSIONS.SETUP_SYSTEMS_IPWHITELIST_VIEW}>
      {_.isEmpty(pairs) ?
        <IpLists /> :
        <AddAndEditIpList currentId={pairs.id} />
      }
    </Permission>
  );
};

export default withRouter(IpWhiteLists);



// WEBPACK FOOTER //
// ./src/views/Setup/IpWhiteLists/container/index.jsx